import Vue from 'vue';
import Vuex from 'vuex';
import Person from '@/lib/Person';
import Step from '@/lib/Step';
import { Question } from '@/lib/Question';
import Section from '@/lib/Section';
import Branch from '@/lib/Branch';
import Axios, { AxiosResponse } from 'axios';
import ResponseType from '@/lib/ResponseType';
import { ResponseGroup } from '@/lib/ResponseGroup';
import Condition from '@/lib/Condition';
import Operator from '@/lib/Operator';
import Choice from '@/lib/Choice';
import { api } from '@/Api';
import Response from '@/lib/Response';
import { Pack } from '@/lib/Pack';
import { Comparison } from '@/lib/Comparison';
import router from '@/router';
import { BranchCategory } from '@/lib/BranchCategory';
import { Guarantee } from '@/lib/Guarantee';
import { PackGuarantee } from '@/lib/PackGuarantee';
import { HouseForm, HouseOverviewForm } from '@/lib/HouseForm';
import { ArrayAccessDictionary } from '@/lib/ArrayAccessDictionary';
import { PackCategory } from '@/lib/PackCategory';
import * as Q from 'q';
import { months } from 'moment';
import Town from "@/lib/Town";
import { ArraySectionItem } from "./lib/ArraySectionItem";
import Insurer from "./lib/Insurer";


Vue.use(Vuex);

export enum Page {
    BranchPage,
    StepPage,
    HomePage,
}

let debounceCompareId = 0;

export default new Vuex.Store(
    {
        state: {
            insurerLock: null,
            branches: [],
            knownUser: localStorage.getItem('knownUser') ? JSON.parse(localStorage.getItem('knownUser')!) : false,
            steps: [],
            sections: [],
            responseTypes: [],
            person: new Person(),
            partner: '',
            responseGroups: [],
            questions: [],
            isInitialized: false,
            insurers: [],
            banner: false,
            loading: true,
            commonGuarantees: [],
            missing: [],
            maxRgCookies: 5,
            otherGuarantees: [],
            responseGroupCookies: [],
            allowUploadAnswer: true,
            currentBranch: null,
            currentContractUuid: null,
            currentContractGroupUuid: null,
            currentPage: Page.HomePage,
            operators: {},
            userMail: '',
            hotReloadSteps: [],
            towns: [],
            town: null,
            crossBranchSteps: [],
            emailRegex: new RegExp('(?:[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])'),
            currentStep: null,
            currentResponseGroup: null,
            responses: [],
            currentStepIsValid: false,
            currentStepIsFirst: true,
            currentStepIsLast: false,
            comparison: null,
            currentInsuranceDuration: 'yearly',
            branchCategories: [],
            currentBranchCategory: null,
            arraySections: null,
            packs: [],
            guarantees: [],
            modalPayload: null,
            startDate: null,
            order: null,
            answerSavingNumber: 0,
            packCategories: [],
            comparing: false,
            sleep: (ms: number) => {
                return new Promise(resolve => setTimeout(resolve, ms));
            },
            tenant: localStorage.getItem('zone') !== null ? JSON.parse(localStorage.getItem('zone')!) : {
                'iso': 'ci',
                'name': 'Côte d\'ivoire',
            },
            tenants: [
                {
                    'iso': 'ci',
                    'name': 'Côte d\'ivoire',
                },
                {
                    'iso': 'sn',
                    'name': 'Sénégal',
                },
            ],
            backendUrl: process.env.VUE_APP_BACKEND_URL,
            // packCategories: [],
            packCategory: 1,
            selectedPack: null,
            transactionToken: null,
            error: '',
            splashDisplayed: false,
            message: '',
            user: null,
            wideScreen: true,
            healthSurvey: [],
            standaloneConditions: [],
            healthSurveyIsValid: false,
            houseOverView: {
                stepId: 7,
                questionMapping: {
                    houseType: 22,
                    size: 23,
                    typeOfVilla: 24,
                    floor: 25,
                    numberOfRooms: 26,
                    municipality: 27,
                    neighborhood: 28,
                    ownership: 29,
                },

            },
        },
        mutations: {
            setTenant(state, tenant) {
                state.tenant = tenant;
            },
            setSplashDisplayed(state, displayed: boolean) {
                state.splashDisplayed = displayed
            },
            toggleHealthSurveyIsValid(state, isValid) {
                state.healthSurveyIsValid = isValid;
            },
            showBanner(state: any) {
                state.banner = true;
            },
            addQuestionToSurvey(state: any, payload: any) {
                let asset = state.healthSurvey.find((existing: any) => existing.assetId === payload.assetId) || null;
                if (null === asset) {
                    asset = {
                        assetId: payload.assetId,
                        assetTitle: payload.assetTitle,
                        questions: [],
                    };
                    asset.questions.push(payload.question);
                    state.healthSurvey.push(asset);
                } else {
                    asset.questions.push(payload.question);
                }
            },
            hideBanner(state: any) {
                state.banner = false;
            },
            addStandaloneCondition(state: any, condition: Condition) {
                state.standaloneConditions.push(condition);
            },
            openModal(state: any, payload) {
                state.modalPayload = payload;
            },
            saving(state: any) {
                state.answerSavingNumber = state.answerSavingNumber + 1;
            },
            saved(state: any) {
                state.answerSavingNumber = state.answerSavingNumber - 1;
            },
            addTown(state: any, town: Town) {
                state.towns.push(town);
            },
            selectTown(state: any, town: Town) {
                state.town = town;
            },

            closeModal(state: any) {
                state.modalPayload = null;
            },
            setWideScreen(state: any, width) {
                state.wideScreen = width > 1024;
            },
            comparing(state: any) {
                state.comparing = true;
            },
            comparingDone(state: any) {
                state.comparing = false;
            },
            loading(state: any) {
                state.loading = true;
            },
            throwError(state: any, error: string) {
                state.error = error;
                setTimeout(() => {
                    state.error = '';
                }, 10000);
            },
            loadCookieRgs(state: any, rgs) {
                state.responseGroupCookies = []
                rgs.slice().reverse().forEach((rg: any) => {
                    state.responseGroupCookies.push(rg);
                });
            },
            discardError(state: any) {
                state.error = '';
            },
            showMessage(state: any, message: string) {
                state.message = message;
                setTimeout(() => {
                    state.message = '';
                }, 10000);
            },
            discardMessage(state: any) {
                state.message = '';
            },
            updatePackCategory(state, category: number) {
                state.packCategory = category;
            },
            updateTransactionToken(state: any, transactionToken: string) {
                state.transactionToken = transactionToken;
            },
            selectPack(state, pack: Pack) {
                state.selectedPack = pack;
            },
            resetSelectedPack(state) {
                state.selectedPack = null;
            },
            updateStartDate(state, startDate) {
                state.startDate = startDate;
            },
            addPack(state, pack: Pack) {
                if (!state.packs.includes(pack)) {
                    state.packs.push(pack);
                }
            },
            addPackCategory(state, packCategory: PackCategory) {
                if (!state.packCategories.includes(packCategory)) {
                    state.packCategories.push(packCategory);
                }
            },
            addGuarantee(state, guarantee: Guarantee) {
                if (!state.guarantees.find((existing: Guarantee) => existing.id === guarantee.id)) {
                    state.guarantees.push(guarantee);
                }
            },
            updateCurrentBranchCategory(state, category: BranchCategory) {
                state.currentBranchCategory = category;
            },
            addBranchCategory(state, category: BranchCategory) {
                if (!state.branchCategories.includes(category)) {
                    state.branchCategories.push(category);
                    if (null === state.currentBranchCategory) {
                        state.currentBranchCategory = category;
                    }
                }
            },
            updateInsuranceDuration(state, duration) {
                if (['yearly', 'quarterly', 'monthly', 'biannual'].includes(duration)) {
                    state.currentInsuranceDuration = duration;
                }
            },
            addComparison(state: any, comparison: Comparison) {
                state.comparison = comparison;
            },
            resetComparison(state: any) {
                state.comparison = null;
            },
            disallowAnswerUpload(state: any) {
                state.allowAnswerUpload = false;
            },
            allowAnswerUpload(state: any) {
                state.allowAnswerUpload = true;
            },
            setCurrentResponseGroup(state: any, responseGroup: ResponseGroup) {
                state.currentResponseGroup = responseGroup;
            },
            deleteResponseGroup(state: any, responseGroup: ResponseGroup) {
                if (state.currentResponseGroup && state.currentResponseGroup.id === responseGroup.id) {
                    state.currentResponseGroup = null;
                }
                const responses = state.responses.filter((response: Response) => {
                    return response.responseGroup.id !== responseGroup.id;
                });
                responses.forEach((response: any) => {
                    state.responses.splice(state.responses.indexOf(response), 1);
                });
                state.responseGroups.splice(state.responseGroups.indexOf(responseGroup), 1);
            },
            showBranch(state: any, branch: Branch) {
                state.currentBranch = branch;
                state.currentStep = branch.currentStep;
                state.currentPage = Page.BranchPage;
            },
            setCurrentBranch(state: any, branch: Branch) {
                state.currentBranch = branch;
            },
            showHomePage(state: any) {
                state.currentPage = Page.HomePage;
            },
            loaded(state: any) {
                state.loading = false;
            },
            initialize(state: any) {
                state.isInitialized = true;
            },
            addBranch(state: any, branch: Branch) {
                state.branches.push(branch);
            },
            addInsurer(state: any, insurer: Insurer) {
                state.insurers.push(insurer);
            },
            setInsurerLock(state: any, insurer: Insurer) {
                state.insurerLock = insurer;
            },
            setOrder(state: any, order) {
                state.order = order;
                if (order.town) {
                    state.town = new Town(order.town.id, order.town.label);
                }
            },
            updateMissing(state: any, missing) {
                state.missing = missing
            },
            addStep(state: any, step: Step) {
                if (step.branch && !step.hotReload) {
                    state.steps.push(step);
                }
                if (!step.branch) {
                    state.crossBranchSteps.push(step);
                }
                if (step.branch && step.hotReload) {
                    state.hotReloadSteps.push(step);
                }
            },
            addSection(state: any, section: Section) {
                state.sections.push(section);
            },
            addQuestion(state: any, question: Question) {
                state.questions.push(question);

            },
            addResponseType(state: any, responseType: ResponseType) {
                state.responseTypes.push(responseType);
            },
            addResponseGroup(state: any, responseGroup: ResponseGroup) {
                state.responseGroups.push(responseGroup);
            },
            reset(state: any) {
                state.currentResponseGroup = null;
                state.currentStep = null;
                if (state.currentBranch) {
                    state.currentBranch.currentStep = undefined;
                }

                state.currentStepIsValid = false;
                state.currentStepIsFirst = true;
                state.currentStepIsLast = false;
                state.responses = [];
                state.questions.forEach((question: Question) => question.currentResponse = undefined);
            },
            previousStep(state: any) {
                state.currentResponseGroup.previousStep();
            },
            nextStep(state: any) {
                state.currentResponseGroup.nextStep();
            },
            addResponse(state: any, response: Response) {
                state.responses.push(response);
            },
            setCurrentStep(state: any, step: Step) {
                state.currentStep = step;
            },
            setCurrentContractUuid(state: any, uuid) {
                state.currentContractUuid = uuid;
            },
            setCurrentContractGroupUuid(state: any, uuid) {
                state.currentContractGroupUuid = uuid;
            },
            user(state: any, user: any) {
                state.user = user;
            },
        },
        actions: {
            loadHealthSurvey(context, data: any) {
                let stepObject: null | Step = null;
                let branch: null | Branch = null;
                let responseGroup: null | ResponseGroup = null;
                data.forEach((asset: any) => {
                    let sectionObject: null | Section = null;
                    const step = asset.step;
                    branch = branch || context.state.branches.find((branch: Branch) => branch.id === step.branchId);
                    responseGroup = responseGroup || new ResponseGroup(branch!);
                    responseGroup.id = context.state.order.responseGroupId;
                    context.commit('setCurrentResponseGroup', responseGroup);
                    stepObject = stepObject ||
                        context.state.steps.find((existing: Step) => existing.id === step.id) ||
                        new Step(step.id, step.title, step.description, branch ? branch : null, step.wide, step.iconName, step.hotReload);
                    context.commit('addStep', stepObject);
                    asset.sections.forEach((section: any) => {
                        if (!sectionObject || sectionObject.additionalIndex !== asset.additionalIndex) {
                            sectionObject = new Section(section.id, section.title, section.description, stepObject!, section.additionalLabel, section.multiple, section.incrementAdditional, section.arraySectionIds);
                            sectionObject.additionalIndex = asset.additionalIndex;
                            stepObject!.sections.push(sectionObject);
                            context.commit('addSection', sectionObject);
                        }
                    });
                    asset.questions.forEach((question: any) => {
                        const responseType = context.state.responseTypes.find((responseType: ResponseType) => responseType.id === question.responseTypeId);
                        const questionObject = new Question(question.id, responseType!, question.label, sectionObject!, question.required, question.multiple, question.regex, question.description, question.errorMessage, question.filteredByQuestionId, question.hasComment, question.conditionIsOr, question.displayWidth, question.placeholder, question.inline, question.unit, question.defaultValue, question.parentId);
                        question.options.forEach((choice: any) => {
                            questionObject.options.push(new Choice(choice.id, choice.label, choice.code, choice.description));
                        });
                        sectionObject!.questions.push(questionObject);
                        questionObject.response = new Response(questionObject, responseGroup!);
                        context.commit('addQuestionToSurvey', { assetId: asset.assetId, assetTitle: asset.title, question: questionObject });
                    });
                });
                context.commit('setCurrentBranch', branch);
            },

            init(context, data: any) {

                data.branches.forEach((branch: any) => {
                    const category = branch.category;
                    let categoryObject = context.state.branchCategories.find((branchCategory: BranchCategory) => branchCategory.id === category.id);
                    if (!categoryObject) {
                        categoryObject = new BranchCategory(category.id, category.label, category.slug);
                        context.commit('addBranchCategory', categoryObject);
                    }

                    const branchObject = new Branch(
                        branch.id,
                        branch.title,
                        branch.description,
                        branch.icon,
                        branch.picture,
                        branch.slug,
                        categoryObject!,
                        branch.activated,
                        branch.activateComparison,
                        branch.noComparisonNotice,
                        branch.excelTemplateFile,
                        branch.hubspotFormId,
                        branch.ranking,
                        branch.showOnHomepage,
                        branch.filters,
                        branch.noDeductible,
                    );

                    context.commit('addBranch', branchObject);
                });

                let insurerLockSlug = window.location.host.split('.')[1] ? window.location.host.split('.')[0] !== 'comparateur' ? window.location.host.split('.')[0] : null : null;
                if (window.location.host === 'wiassur.web:8080') {
                    insurerLockSlug = null;
                }
                if (data.insurers) {
                    data.insurers.forEach((insurer: any) => {
                        const src = insurer.logo ? insurer.logo.src : 'default.png';
                        const insurerObject = new Insurer(insurer.id, insurer.label, insurer.slug, src);
                        context.commit('addInsurer', insurerObject);
                    });
                    const insurerLock = context.state.insurers.find((insurer: Insurer) => insurer.slug === insurerLockSlug);

                    if (insurerLock) {
                        context.commit('setInsurerLock', insurerLock);
                    }
                }
                data.steps.forEach((step: any) => {
                    const branch = context.state.branches.find((branch: Branch) => branch.id === step.branchId);
                    const stepObject = new Step(step.id, step.title, step.description, branch ? branch : null, step.wide, step.iconName, step.hotReload);
                    if (branch && !stepObject.hotReload) {
                        branch.addStep(stepObject);
                    }
                    context.commit('addStep', stepObject);
                });
                data.packCategories.forEach((packCategory: any) => {
                    const pcObject = new PackCategory(packCategory.id, packCategory.label, packCategory.branchId);
                    context.commit('addPackCategory', pcObject);
                });
                let arraySectionsIdList: any = [];
                data.sections.forEach((section: any) => {
                    let step = context.state.steps.find(
                        (step: Step) => step.id === section.stepId) ||
                        context.state.crossBranchSteps.find((step: Step) => step.id === section.stepId) ||
                        context.state.hotReloadSteps.find((step: Step) => step.id === section.stepId);

                    if (!step) {
                        return;
                    }
                    const sectionObject = new Section(section.id, section.title, section.description, step, section.additionalLabel, section.multiple, section.incrementAdditional, section.arraySectionIds);
                    if (section.arraySectionIds.length) {
                        arraySectionsIdList[section.id] = section.arraySectionIds;
                    }
                    sectionObject.labelQuestionIds = section.compositeLabelQuestionsIds;
                    step.sections.push(sectionObject);
                    context.commit('addSection', sectionObject);
                });
                arraySectionsIdList.forEach((arraySectionIds: number[], sectionId: number) => {
                    arraySectionIds.forEach((arraySectionId: number, key: number) => {
                        const additionalIndex = ((sectionId * 100) + '') + key;
                        const section: Section = context.getters.getSection(arraySectionId);
                        section.additionalIndex = parseInt(additionalIndex);
                    });
                });

                data.responseTypes.forEach((responseType: any) => {
                    context.commit('addResponseType', new ResponseType(responseType.id, responseType.label, responseType.template, responseType.code, responseType.className));
                });

                data.questions.forEach((question: any) => {
                    const sectionObject: Section = context.state.sections.find((section: Section) => section.id === question.sectionId);
                    if (!sectionObject) {
                        return;
                    }

                    const responseType = context.state.responseTypes.find((responseType: ResponseType) => responseType.id === question.responseTypeId);
                    const questionObject = new Question(question.id, responseType, question.label, sectionObject, question.required, question.multiple, question.regex, question.description, question.errorMessage, question.filteredByQuestionId, question.hasComment, question.conditionIsOr, question.displayWidth, question.placeholder, question.inline, question.unit, question.defaultValue, question.parentId);
                    question.options.forEach((choice: any) => {
                        questionObject.options.push(new Choice(choice.id, choice.label, choice.code, choice.description));
                    });
                    const responseGroup = context.state.responseGroups.find((responseGroup: ResponseGroup) => sectionObject.step.branch.id === responseGroup.branch.id);
                    if (sectionObject.arraySectionIds.length) {
                        sectionObject.arraySectionIds.forEach((id: number) => {
                            const additionalSection = context.getters.getSection(id);

                            const additionalQuestionObject = Section.createAdditionalQuestion(question, sectionObject.id, sectionObject.additionalIndex, additionalSection);
                            additionalSection.questions.push(additionalQuestionObject);
                            additionalQuestionObject.response = new Response(additionalQuestionObject, responseGroup);
                            additionalQuestionObject.response.additionalIndex = sectionObject.additionalIndex;
                        });
                    } else {
                        sectionObject.questions.push(questionObject);
                        questionObject.response = new Response(questionObject, responseGroup);
                        context.commit('addQuestion', questionObject);
                    }
                });
                data.guarantees.forEach((guarantee: any) => {
                    const guaranteeObject = new Guarantee(
                        guarantee.id,
                        guarantee.name,
                        '',
                        guarantee.comment,
                        guarantee.conditions.map((condition: any) => new Condition(condition.id, context.getters.getOperator(condition.operator), condition.testingQuestionId, condition.value || '')),
                        guarantee.conditionsAreOptional,
                    );
                    guaranteeObject.branch = guarantee.branch;
                    context.commit('addGuarantee', guaranteeObject);
                });
                data.conditions.forEach((condition: any) => {
                    const conditionObject = new Condition(condition.id, context.getters.getOperator(condition.operator), condition.testingQuestionId, condition.value || '');
                    if (condition.hasOwnProperty('questionId') && condition.questionId) {
                        const question = context.getters.getQuestion(condition.questionId);
                        if (question) {
                            question.conditions.push(conditionObject);
                            // console.warn('no question with id ' + condition.questionId + ', skipping condition ' + condition.id);
                        }

                    } else if (condition.hasOwnProperty('sectionId') && condition.sectionId) {
                        const section = context.getters.getSection(condition.sectionId);
                        if (section) {
                            section.conditions.push(conditionObject);
                            // console.warn('no section with id ' + condition.sectionId + ', skipping condition ' + condition.id);
                        }
                    } else {
                        context.commit('addStandaloneCondition', conditionObject);
                    }
                    conditionObject.init();
                });
                // data.arraySections.forEach((arraySection: any) => {
                //     const section = context.getters.getSection(arraySection.subjectId);
                //
                //     const additional = context.getters.getSection(arraySection.additionalSectionId) as Section;
                //     if (!section || !additional) {
                //         return;
                //     }
                //     const conditions = context.state.standaloneConditions.filter(
                //         (standAloneCondition: Condition) => arraySection.conditions.some(
                //             (condition: any) => condition.id == standAloneCondition.id
                //         )
                //     );
                //
                //     // const arraySectionItem = new ArraySectionItem(section,
                //     // additional, arraySection.additionalLabel, context.state.questions.filter(
                //     // (question: Question) => arraySection.compositeLabelQuestionsIds.includes(question.id)),
                //     // conditions);
                //     // section.arraySectionItems.push(arraySectionItem);
                // });


                context.commit('initialize');
            },
            loadTowns(context) {
                api.loadTowns().then((response: AxiosResponse) => {
                    const towns = response.data.data;
                    towns.forEach((town: any) => {
                        context.commit("addTown", new Town(town.id, town.label));
                    });
                });
            },
            removeAdditionalResponseGroup(context, section: Section) {
                context.commit('loading');
                section.questions.forEach((question: Question) => {
                    context.state.responses.splice(context.state.responses.findIndex((existing: Response) => existing === question.currentResponse), 1);
                    context.state.questions.splice(context.state.questions.findIndex((existing: Question) => existing.id === question.id), 1);
                });
                const step = section.step;
                step.sections.splice(step.sections.findIndex((stepSection: Section) => stepSection == section));
                context.state.sections.splice(context.state.sections.findIndex((existing: Section) => section == existing), 1);
                if (section.parentSection !== null) {
                    section.parentSection.children.splice(section.parentSection.children.findIndex((child: Section) => child == section));
                }
                api.removeSectionAnswers(context.state.currentResponseGroup.id, section.id === 0 ? section.parentSection!.id : section.id, section.additionalIndex || 0).then((response: AxiosResponse) => {
                    if (response.data.status === 'failure') {
                        context.commit('throwError', response.data.status.message);
                    }
                    context.commit('loaded');
                });
            },
            notifyNewBranch(context, payload) {
                context.commit('loading');
                api.notifyNewBranch(payload).then((response: AxiosResponse) => {
                    context.commit('loaded');
                    const data = response.data;
                    context.commit(data.status === 'failure' ? 'throwError' : 'showMessage', data.message);
                });
            },
            pay(context, parameters) {
                return api.pay(parameters);
            },
            filterQuestion(context, payload: any) {
                const question: Question = payload.question || payload;
                const page = payload.page || 1;
                let search = null;
                if (payload.hasOwnProperty('search')) {
                    search = payload.search;
                }
                // console.log(search);
                if (question.responseType.template !== 'entity') {
                    // console.warn('Could not filter the question choices as the question is not of type entity but ' + question.responseType.template);
                    return [];
                }
                return api.filterQuestion(question, question.hasIcons() ? '' : search !== null ? search : question.currentResponse!.value, page);
            },
            saveOrder(context, payload) {
                const pack: Pack = payload.pack;
                context.commit('loading');
                api.order(pack, payload.responseGroupId).then((response: AxiosResponse) => {
                    // if(response )
                    const data = response.data;
                    data.amount = 10;
                    context.commit('setOrder', data.data);
                    if (payload.print) {
                        let routeData = router.resolve({
                            name: 'order',
                            params: { order: data.data.id },
                            query: { print: 'true' }
                        });
                        window.open(routeData.href, '_blank');
                    } else {
                        router.push({ name: 'order', params: { order: data.data.id } });
                    }
                });
            },
            getResponseOrCreate(context, question: Question) {
                let response = context.getters.getResponse(question);
                if (!response) {
                    response = new Response(question, context.state.currentResponseGroup);
                    if (question.section.multiple) {
                        response.additionalIndex = question.section.additionalIndex;
                    }
                    context.commit('addResponse', response);
                }
                return response;
            },
            compare(context, payload) {
                clearTimeout(debounceCompareId);
                debounceCompareId = setTimeout(() => {
                    context.commit('comparing');
                    context.commit('updateMissing', [])
                    api.compare(payload).then((response: AxiosResponse) => {
                        if (response.status === 200) {
                            const data: any = response.data.data.result;
                            context.commit('updateMissing', response.data.missing)
                            const category = response.data.data.category;
                            const sortedByCheapest: Pack[] = [];
                            let cheapest: Pack | null = null;
                            data.sortedByCheapest.forEach((dataPack: any) => {
                                const packGuarantees: Array<PackGuarantee> = [];
                                dataPack.pack.configuredPackGuarantees.forEach((dataPackGuarantee: any) => {
                                    const dataGuarantee = dataPackGuarantee.guarantee;
                                    const guarantee = context.getters.getGuarantee(dataGuarantee.id) ||
                                        new Guarantee(
                                            dataGuarantee.id,
                                            dataGuarantee.name,
                                            '',
                                            dataGuarantee.comment,
                                            dataGuarantee.conditions.map((condition: any) => new Condition(condition.id, context.getters.getOperator(condition.operator), condition.testingQuestionId, condition.value || '')),
                                            dataGuarantee.conditionsAreOptional,
                                        );
                                    guarantee.branch = data.branch;
                                    const ceiling = dataPackGuarantee.ceiling ? dataPackGuarantee.ceiling.trim() : '';
                                    const franchise = dataPackGuarantee.franchise ? dataPackGuarantee.franchise.trim() : '';
                                    packGuarantees.push(new PackGuarantee(
                                        guarantee,
                                        ceiling,
                                        franchise,
                                        dataPack.optionals[guarantee.id] || 0,
                                        dataPackGuarantee.optional, dataPackGuarantee.forced));
                                    context.commit('addGuarantee', guarantee);

                                });
                                const insurerLogo = dataPack.pack.insurer.logo ? dataPack.pack.insurer.logo.src : null;
                                const pack = new Pack(
                                    dataPack.pack.id,
                                    dataPack.pack.name,
                                    dataPack.premium,
                                    dataPack.premiumSplitting,
                                    packGuarantees,
                                    dataPack.pack.insurer.label,
                                    insurerLogo,
                                    dataPack.pack.criteria,
                                    dataPack.pack.packFiles,
                                    dataPack.pack.packAttributes,
                                );

                                if (pack.id === data.cheapest.pack.id) {
                                    cheapest = pack;
                                }
                                pack.branch = data.branch;
                                sortedByCheapest.push(pack);
                                context.commit('addPack', pack);
                            });
                            context.commit(
                                'addComparison',
                                new Comparison(
                                    cheapest!,
                                    sortedByCheapest,
                                    null,
                                    null,
                                    null,
                                    null,
                                    data.branch,
                                    data.period,
                                )
                            );
                            if (payload.next) {
                                payload.next();
                            }
                            context.commit('comparingDone');
                        } else {
                            context.commit('throwError', "An error occured that prevented the comparison");
                        }
                    });
                }, 3000);
            },
        },
        getters: {
            getHouseFormQuestions(state: any): HouseForm | null {
                if (null === state.currentResponseGroup) {
                    return null;
                }
                const step = state.currentResponseGroup.getCurrentStep() as Step;

                const formArray: ArrayAccessDictionary<Question> = {};
                let form = formArray as ArrayAccessDictionary<Question>;
                const questionsGrouped = state.currentStep.sections.map((section: Section) => {
                    return section.questions;
                });
                const questions = [].concat(...questionsGrouped);
                switch (step.id) {
                    case state.houseOverView.stepId:
                        form = <HouseOverviewForm>formArray;
                        break;
                }
                //const form = step.id === state.houseOverView.stepId ? <HouseOverviewForm>formArray : formArray as ArrayAccessDictionary<Question>;
                questions.forEach((question: Question) => {
                    Object.entries(state.houseOverView.questionMapping).forEach(([property, questionId]) => {
                        if (questionId === question.id) {
                            form[<string>property] = question;
                        }
                    });
                });
                return new HouseForm(form);
            },
            getResponse: (state: any) => (question: Question) => {
                const response = state.responses.find((existing: Response) => existing.question.id === question.id && existing.responseGroup.id === state.currentResponseGroup.id);
                return response;
            },
            getQuestion: (state: any) => (questionId: number) => {
                return state.questions.find((question: Question) => question.id === questionId);
            },
            getSection: (state: any) => (sectionId: number) => {
                return state.sections.find((section: Section) => section.id === sectionId);
            },
            getBranch: (state: any) => (branchId: number) => {
                return state.branches.find((branch: Branch) => branch.id === branchId);
            },
            questionsOfSection: (state: any) => (section: Section) => {
                return state.questions.filter((question: Question) => question.section === section);
            },
            sectionsOfStep: (state: any) => (step: Step) => {
                return state.sections.filter((section: Section) => section.step === step);
            },
            stepsOfBranch: (state: any) => (branch: Branch) => {
                return state.steps.filter((step: Step) => step.branch === branch);
            },
            isBranchDisplayed: (state: any) => (branch: Branch) => {
                return state.currentPage === Page.BranchPage && state.currentBranch === branch;
            },
            isBranchTileDisplayed: (state: any) => (branch: Branch) => {
                return state.currentPage === Page.HomePage || (state.currentPage === Page.BranchPage && state.currentBranch === branch);
            },
            currentStepIsLast: (state) => {
                if (null === state.currentResponseGroup) {
                    return false;
                }
                const step = state.currentResponseGroup.getCurrentStep();
                const index = state.currentResponseGroup.branch.steps.findIndex((branchStep: Step) => branchStep.id === step.id);
                if (index > -1) {
                    return index === (state.currentResponseGroup.branch.steps.length - 1);
                }
                return false;
            },
            currentStepIsFirst: (state) => {
                if (null === state.currentResponseGroup) {
                    return true;
                }
                const step = state.currentResponseGroup.getCurrentStep();
                const index = state.currentResponseGroup.branch.steps.findIndex((branchStep: Step) => branchStep.id === step.id);
                if (index > -1) {
                    return index === 0;
                }
                return false;
            },
            stepIsFirst: (state: any) => (step: Step) => {
                const index = state.currentBranch.steps.findIndex((branchStep: Step) => branchStep.id === step.id);
                if (index > -1) {
                    return index === 0;
                }
                return false;
            },
            stepIsLast: (state: any) => (step: Step) => {
                const index = state.currentBranch.steps.findIndex((branchStep: Step) => branchStep.id === step.id);
                if (index > -1) {
                    return index === (state.currentBranch.steps.length - 1);
                }
                return false;
            },
            branchCurrentStep: (state: any) => (branch: Branch) => {
                if (!branch.currentStep) {
                    if (branch.steps.length) {
                        branch.currentStep = branch.steps[0];
                    } else {
                        return null;
                    }
                }
                return branch.currentStep;
            },
            getOperator: (state: any) => (args: any) => {
                const id = args.id;
                if (!state.operators[id]) {
                    state.operators[id] = new Operator(args.id, args.symbol, args.label);
                }
                return state.operators[id];
            },
            branchResponseGroups: (state) => (branchSlug: string) => {
                return state.responseGroups.filter((responseGroup: ResponseGroup) => {
                    return responseGroup.branch.slug = branchSlug;
                });
            },
            branchFromSlug: (state) => (slug: string) => {
                return state.branches.find((branch: Branch) => {
                    return branch.slug === slug;
                });
            },
            responseGroup: (state) => (id: any) => {
                return state.responseGroups.find((responseGroup: ResponseGroup) => id == responseGroup.id);
            },
            getCurrentInsuranceDurationLabel: (state) => {
                const period = state.comparison.period;
                if (period === 'DUR4') {
                    return 'an';
                } else if (period === 'DUR2') {
                    return 'trimestre';
                } else if (period === 'DUR3') {
                    return 'semestre';
                } else {
                    return 'mois';
                }
            },
            getCurrentResponse: (state) => (question: Question) => {
                let currentResponse = state.responses.find((response: Response) => {
                    return response.question.id == question.id &&
                        (response.responseGroup.id == state.currentResponseGroup.id) &&
                        response.question.section.additionalIndex == question.section.additionalIndex;
                });

                if (!currentResponse) {
                    currentResponse = new Response(question, state.currentResponseGroup);

                    if (question.section.multiple || question.section.arraySectionIds.length) {
                        currentResponse.additionalIndex = question.section.additionalIndex;
                    }
                    state.responses.push(currentResponse);
                }
                return currentResponse;
            },
            getPack: (state) => (id: number) => {
                return state.packs.find((pack: Pack) => pack.id == id);
            },
            getGuarantee: (state) => (id: number) => {
                return state.guarantees.find((guarantee: Guarantee) => guarantee.id === id);
            },
            getCurrentBranches: (state) => {

            },
            getDisplayableGuarantees: (state) => (x: any) => {
                return state.guarantees.filter((guarantee: Guarantee) => guarantee.canDisplay());
            },
            getCrossStepQuestions: (state) => {
                const sectionQuestions = state.crossBranchSteps.map((crossBranchStep: Step) =>
                    crossBranchStep.sections.map((section: Section) => section.questions),
                );
                return sectionQuestions.flat(2);
            },
            getHotReloadQuestions: (state) => {
                const sectionQuestions = state.hotReloadSteps.map((hotReloadStep: Step) =>
                    hotReloadStep.sections.map((section: Section) => section.questions),
                );
                return sectionQuestions.flat(2);
            },
            getCurrentBranchHotReloadQuestion: (state) => {
                const sectionQuestions = state.hotReloadSteps.filter((step: Step) => step.branch!.id === state.currentBranch.id).map((hotReloadStep: Step) =>
                    hotReloadStep.sections.map((section: Section) => section.questions),
                );
                return sectionQuestions.flat(2);
            }
        },

    },
);
